'use strict';

angular.module('licensure.services')
    .factory('UserInspectors', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/UserInspectors', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (user_inspector) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/UserInspectors/';
                if (!isUndefined(user_inspector.id)) {
                    method = 'PUT'
                    url += user_inspector.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        user_inspector: user_inspector
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/UserInspectors/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;